import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@app/redux/root-reducer';

const common = (state: RootState) => state.commonSlice;

export const selectIsAuthenticated = (store: RootState) => Boolean(store.commonReducer.token);

export const selectAuthToken = (store: RootState) => store.commonReducer.token;

export const selectSelectedProjectId = (store: RootState) => store.commonReducer.selectedProjectId;

export const selectLoader = createSelector(
  common,
  (data) => data.loaders?.filter((loader) => loader.options?.global !== false).slice(-1)[0]
);
